export default __webpack_public_path__ + "static/media/FooterLogo.8f867710.svg";